export default __webpack_public_path__ + "static/media/kb-image.e310b4d3.jpg";